export default {
  // ========== Encabezado ==========
  designTitle: 'Diseño Instruccional',
  tabMethods: 'Modelos Instruccionales',
  tabStatuses: 'Estados',
  statusEntity: 'Estado',
  statusesHint:
    'Son los estados de avance que puede tener una actividad, un Contenedor o el diseño completo.',
  statusesEmpty: 'Aún no hay estados definidos.',
  statusOrder: 'Orden',
  statusOrderInvalid: 'Ingrese un número mayor o igual a 1.',
  statusOrderHint: 'Define en qué posición aparece dentro del proceso.',
  statusColor: 'Color',
  statusActive: 'Activo',
  statusActiveHint:
    'Un estado inactivo deja de ofrecerse, pero las piezas que ya lo tienen lo conservan.',
  statusDeleteWarning:
    'Las actividades, Contenedores y diseños que tengan este estado quedarán sin estado. No se elimina nada más.',
  methodEntity: 'Modelo Instruccional',
  methodsEntity: 'Modelos Instruccionales',
  momentEntity: 'Momento Instruccional',
  momentsEntity: 'Momentos Instruccionales',

  // ========== Tabla de modelos ==========
  fieldName: 'Nombre',
  fieldDescription: 'Descripción',
  fieldMoments: 'Momentos',
  fieldOrder: 'Orden',
  fieldColor: 'Color',
  momentsCount: 'Sin momentos | 1 momento | {count} momentos',
  manageMomentsTooltip: 'Administrar los momentos de este modelo',
  methodsEmpty:
    'Aún no hay modelos instruccionales. Crea el primero para habilitar el Diseño Instruccional.',

  // ========== Momentos ==========
  momentsModalTitle: 'Momentos de {method}',
  momentsEmpty:
    'Este modelo aún no tiene momentos. Crea el primero (por ejemplo: Activación, Fundamentación, Aplicación, Integración).',
  momentsHelp:
    'Los momentos se muestran en el orden indicado y agrupan las actividades del Diseño Instruccional.',
  momentNamePlaceholder: 'Ej: Activación',

  // ========== Avisos ==========
  deleteMethodWarning:
    'Se eliminarán también sus momentos, y las actividades que los usaran quedarán sin momento asignado.',
  deleteMomentWarning:
    'Las actividades del Diseño Instruccional que usen este momento quedarán sin momento asignado.',
  loadError:
    'No fue posible cargar los modelos instruccionales. Intente nuevamente más tarde.',
  saveError: 'No fue posible guardar los cambios. Intente nuevamente.',
  deleteError: 'No fue posible eliminar. Intente nuevamente.',
};
